import Task1_1 from './Task1_1';

export default Task1_1